export enum PropertyType {
  Company = "Company",
}

export const PropertyTypes: PropertyType[] = [PropertyType.Company];
